define('hide_quantity_pricing_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('hide_quantity_pricing_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"product-views-price\"></div> ";
},"useData":true}, 'extensions/SC/GlobalConfigurationExtension/1.0.1/', 'extensions/SC/GlobalConfigurationExtension/1.0.1/', Handlebars);
});